import { getStoredStopId, withStoredStopId } from './stopIds.js';

export function getPreferredStopDirection(preferences, stopId) {
  return preferences?.find(entry => getStoredStopId(entry) === stopId)?.direction === 'outbound'
    ? 'outbound' : 'inbound';
}

export function updatePreferredStopDirection(preferences = [], stopId, direction) {
  if (!stopId || !['inbound', 'outbound'].includes(direction)) return preferences;
  const existing = preferences.find(entry => getStoredStopId(entry) === stopId);
  return [
    ...preferences.filter(entry => getStoredStopId(entry) !== stopId),
    withStoredStopId({ ...existing, direction }, stopId),
  ];
}

export function resolveStopDirectionControl({ directionControl, response, error, evidence, scope }) {
  if (directionControl !== null) return directionControl;
  if (error) return null;
  if (response !== undefined) return response?.direction_control ?? null;
  return evidence?.scope === scope ? evidence.control : null;
}

// A null control means the API supplies validated capability with the board.
// Intent is sent before that evidence arrives; the API decides whether to apply it.
export function getStopDeparturesKey({
  stopId, ready, isArrivalOnly, date, directionControl, preferredDirection,
  services, destination, recent, vehicles,
}) {
  if (!stopId || !ready || isArrivalOnly) return null;
  const params = new URLSearchParams({
    ...(date && { stop_id: stopId }),
    ...(directionControl === null && { include_direction_control: 'true' }),
    ...(date && { date }),
    ...((directionControl === null || directionControl?.enabled) && { direction: preferredDirection }),
    ...(services && { services }),
    ...(destination && { destination }),
    ...(!date && recent && { recent: 'true' }),
    ...(!date && vehicles && { vehicles: 'true' }),
  });
  return date
    ? `/api/stopdeparturesbydate?${params}`
    : `/api/stopdepartures/${stopId}?${params}`;
}
